import React from "react";
import ContenedorPrincipal from "../elementos/basicos/ContenedorPrincipal";
import FormCrearOficina from "../elementos/complejos/FormCrearOficina";
import FormEditarOficina from "../elementos/complejos/FormEditarOficina";

const GestorOficina = ({ crear }) => {
    
  return (
    <>
      <ContenedorPrincipal formaform="true">
      {crear ?
        <FormCrearOficina />
        :
        <FormEditarOficina />
      }
      </ContenedorPrincipal>
    </>
  );
}

export default GestorOficina;